import { ExistingProvider, inject, Injectable } from '@angular/core';
import { EMPTY, filter, switchMap, take, withLatestFrom } from 'rxjs';
import { environment } from '@portal/env';
import { MapApiService } from 'src/app/services/api/map-api.service';
import { AosMapConfig, AosMapConfigToken, FocusAreaDataSource } from '@portal/shared/components/map/map.types';
import { Store } from '@ngrx/store';
import { selectTotalEventsRequestFinished, selectTotalEventsWidget } from '../store/events-monitor.reducer';

@Injectable({ providedIn: 'root' })
export class EventsMonitorMapConfig implements AosMapConfig {
  readonly #mapApi = inject(MapApiService);
  readonly #store = inject(Store);

  readonly tileEndpoint = environment.map.mapEventsGeoUrl;
  readonly itemsCountFieldName = 'eventCount';
  readonly focusAreaDataSource: FocusAreaDataSource = {
    get: payload =>
      this.#store.select(selectTotalEventsRequestFinished).pipe(
        filter(Boolean),
        withLatestFrom(this.#store.select(selectTotalEventsWidget)),
        take(1),
        switchMap(([, { totalEvents }]) => (totalEvents > 0 ? this.#mapApi.getEventsFocusArea(payload) : EMPTY))
      )
  };
}

export const eventsMonitorMapConfigProvider: ExistingProvider = {
  provide: AosMapConfigToken,
  useExisting: EventsMonitorMapConfig
};
